<template>
   <v-container>
      <v-dialog v-model="passworddlg" persistent width="400px" height="200px" @keydown.esc="cancel">
         <v-sheet height="200px">
            <v-row no-gutters>
               <v-col cols="12">
                  <v-toolbar flat dense :class="$globalstore.toolbar_headerclass">
                     <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                        Change Password
                     </v-toolbar-title>
                     <v-icon left color="white" v-else>mdi-lock</v-icon>

                     <v-spacer></v-spacer>
                     <v-btn @click.native="cancelBtnClick" class="mx-2">Cancel</v-btn>
                     <v-btn @click.native="OkBtnClick" class="mx-2">OK</v-btn>
                  </v-toolbar>
               </v-col>
            </v-row>

            <v-row no-gutters>
               <v-col>
                  <!-- <v-card flat>
                     <v-text-field
                        class="px-3"
                        label="Old Password"
                        v-model="edit_oldpass"
                        :append-icon="showold ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showold ? 'text' : 'password'"
                        @click:append="showold = !showold"
                     >
                     </v-text-field>
                  </v-card> -->
                  <v-card flat>
                     <v-text-field
                        class="px-3"
                        label="New Password"
                        v-model="edit_newpass"
                        :append-icon="shownew ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="shownew ? 'text' : 'password'"
                        @click:append="shownew = !shownew"
                     >
                     </v-text-field>
                  </v-card>
                  <v-card flat>
                     <v-text-field
                        class="px-3"
                        label="Confirm New Password"
                        v-model="edit_confirmpass"
                        :append-icon="showconfirm ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showconfirm ? 'text' : 'password'"
                        @click:append="showconfirm = !showconfirm"
                     >
                     </v-text-field>
                  </v-card>
               </v-col>
            </v-row>
         </v-sheet>
      </v-dialog>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </v-container>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         ConfirmDlg,
      },
      data() {
         return {
            // edit_oldpass: "",
            edit_newpass: "",
            edit_confirmpass: "",
            // showold: false,
            shownew: false,
            showconfirm: false,
            passworddlg: false,
         };
      },
      methods: {
         open() {
            this.passworddlg = true;
            // this.edit_oldpass = "";
            this.edit_newpass = "";
            this.edit_confirmpass = "";
            // this.showold = false;
            this.shownew = false;
            this.showconfirm = false;

            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         OkBtnClick() {
            if (this.edit_newpass && this.edit_confirmpass) {
               if (this.edit_newpass !== this.edit_confirmpass) {
                  this.ShowMessage({
                     title: "Error",
                     message: "New password does not match confirm password.",
                     color: "red",
                  });
                  return;
               } else {
                  let credential = {
                     // oldpass: this.edit_oldpass,
                     newpass: this.edit_newpass,
                     confirmpass: this.edit_confirmpass,
                  };
                  this.resolve(true);
                  this.passworddlg = false;
                  this.$emit("input", credential);
               }
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the password form.",
                  color: "red",
               });
               return;
            }
         },

         cancelBtnClick() {
            this.resolve(false);
            this.passworddlg = false;
         },
      },
   };
</script>
